import React, { useEffect, useState, useContext, useRef } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import dayjs from 'dayjs';

import { ItemComboBox, ComboBoxItemType } from '../../../atoms/ComboBox/ItemComboBox';
import NumericEntry_inputEx from '../../../atoms/Input/NumericEntry_inputEx';
import ItemCalenderTimeEx from '../../../atoms/Calendar/ItemCalenderTimeEx';

import { TableBaseStyle } from './PartialDischargeCollectionStyle';
import { SET_PART_DIS } from './PartialDischargeCollection';

type PartialDischargeCollectionBodyProps = {
    setPartDisItem: SET_PART_DIS;
    updateItem: (item: SET_PART_DIS) => void;
    nameDevComboBoxItemList: ComboBoxItemType[];
    mclcTypIdMaxComboBoxItemList: ComboBoxItemType[];
    mclcTypIdPdComboBoxItemList: ComboBoxItemType[];
    partialDischargeIpEnabled: boolean;
};

const PartialDischargeCollectionBody: React.FC<PartialDischargeCollectionBodyProps> = (props: PartialDischargeCollectionBodyProps) => {
    const tableStyle = TableBaseStyle();
    const editRow: SET_PART_DIS = props.setPartDisItem;
    const selectDay: string = dayjs(editRow.LOG_START !== undefined ? editRow.LOG_START : new Date).format('YYYY-MM-DD HH:mm:ss');
    const MEASURE_ITEM_NO = 512;

    const [ipAdrSetting, setIpAdrSetting] = useState<string | undefined>(props.setPartDisItem.IP_ADR); //データ初期値

    /**
     * 重故障変更処理
     * @param val 
     */
    const changeLmtH = (val: number) => {
        editRow.LMT_H = val;
        editRow.isEdit = true;
        props.updateItem(editRow);
    };
    /**
     * 軽故障変更処理
     * @param val 
     */
    const changeLmtL = (val: number) => {
        editRow.LMT_L = val;
        editRow.isEdit = true;
        props.updateItem(editRow);
    };
    /**
     * 収集開始時刻変更処理
     * @param value 
     */
    const changeCalendarValue = (value: string) => {
        editRow.LOG_START = new Date(value);
        editRow.isEdit = true;
        console.debug(["changeCalendarValue", editRow, value]);
        props.updateItem(editRow);
    };
    /**
     * PD強度 重故障変更処理
     * @param val 
     */
    const changeLmtHPd = (val: number) => {
        editRow.LMT_H_PD = val;
        editRow.isEdit = true;
        props.updateItem(editRow);
    };
    /**
     * PD強度 軽故障変更処理
     * @param val 
     */
    const changeLmtLPd = (val: number) => {
        editRow.LMT_L_PD = val;
        editRow.isEdit = true;
        props.updateItem(editRow);
    };
    /**
     * IPアドレス変更処理
     * @param str 
     */
    const changeIpAdr = (str: string) => {
        setIpAdrSetting(str);
        editRow.IP_ADR = str;
        editRow.isEdit = true;
        props.updateItem(editRow);
    }

    /**
     * 機器番号・名称の変更処理
     * @param idx 
     */
    const changeMachineIdx = (idx: number) => {
        editRow.DEV_INDEX = idx;
        if (idx != 0) {
            editRow.ITM_NAME_NO = MEASURE_ITEM_NO;
        }
        editRow.isEdit = true;
        // console.debug(["editRow.DEV_INDEX", idx, editRow.DEV_INDEX]);
        props.updateItem(editRow);
    };

    /**
     * 最大値異常内容変更処理
     * @param idx 
     */
    const changeTypNoMax = (idx: number) => {
        editRow.TYP_NO_MAX = idx;
        editRow.isEdit = true;
        props.updateItem(editRow);
    };

    /**
     * PD強度異常内容変更処理
     * @param idx 
     */
    const changeTypNoPd = (idx: number) => {
        editRow.TYP_NO_PD = idx;
        editRow.isEdit = true;
        props.updateItem(editRow);
    }

    return (
        <>
            <TableRow key={editRow.SET_NO}>
                {/** No. */}
                <TableCell className={tableStyle.bodyCellCenter} style={{ width: '40px' }}>{editRow.SET_NO}</TableCell>
                {/** 実行 */}
                <TableCell className={tableStyle.bodyCellCenter} width={'40px'}>
                    <input
                        type="checkbox"
                        checked={editRow.RUN_FLG != 0 && editRow.RUN_FLG != undefined}
                        onChange={(e) => {
                            editRow.RUN_FLG = e.target.checked ? 1 : 0;
                            editRow.isEdit = true;
                            props.updateItem(editRow);
                        }}
                    />
                </TableCell>
                {/* 機器番号・名称 */}
                <TableCell className={tableStyle.bodyCellLeft} style={{ width: '200px' }}>
                    <ItemComboBox
                        label={''}
                        itemList={props.nameDevComboBoxItemList}
                        value={editRow.DEV_INDEX}
                        labelStyle={tableStyle.labelStyle}
                        itemBoxStyle={tableStyle.itemBoxStyle}
                        onChangeEvent={(e) => {
                            if (typeof e.target.value === 'string') {
                                console.debug(["e.target.value", e.target.value]);
                                changeMachineIdx(parseInt(e.target.value));
                            }
                        }}
                    />
                </TableCell>
                {/* IPアドレス */}
                {props.partialDischargeIpEnabled === false ?
                    null :
                    <TableCell className={tableStyle.bodyCell}
                        onClick={(e) => {
                            console.debug(["onClick"])
                            if (editRow.DEV_INDEX != 0 && editRow.IP_ADR == undefined) {
                                changeIpAdr("0.0.0.0");
                            }
                        }}
                    >
                        {editRow.IP_ADR != undefined && editRow.DEV_INDEX != 0 ?
                            <input
                                className={tableStyle.textField}
                                type="text"
                                maxLength={15}
                                value={ipAdrSetting}
                                onChange={(e) => {
                                    console.debug(['onChangeEvent', e.target.value]);
                                    setIpAdrSetting(e.target.value)
                                }}
                                onBlur={() => {
                                    if (ipAdrSetting != undefined) {
                                        const ip = ipAdrSetting;
                                        if (ip.match(/^\d{1,3}(\.\d{1,3}){3}$/)) {
                                            changeIpAdr(ipAdrSetting);
                                        }
                                        else {
                                            changeIpAdr(editRow.IP_ADR != undefined ? editRow.IP_ADR : '')
                                        }
                                    }

                                }}
                            /> : ''
                        }
                    </TableCell>
                }
                {/* 収集開始時刻 */}
                <TableCell className={tableStyle.tableTd} style={{ width: '180px' }}
                    onClick={(e) => {
                        console.debug(["onClick"])
                        if (editRow.DEV_INDEX != 0 && editRow.LOG_START == undefined) {
                            changeCalendarValue(dayjs(new Date).toString());
                        }
                    }}
                >
                    {editRow.LOG_START != undefined && editRow.DEV_INDEX != 0 ?
                        <ItemCalenderTimeEx
                            label=""
                            labelPosition={1}
                            textCssString={tableStyle.labelStyle}
                            labelCssString={tableStyle.labelStyle}
                            defaultValue={selectDay}
                            onChange={(e) => {
                                console.debug(["onChange date", e])
                                changeCalendarValue(e)
                            }}
                        />
                        : ''
                    }
                </TableCell>
                {/* しきい値 */}
                <TableCell style={{ padding: '0px' }}>
                    <Table >
                        <TableRow >
                            {/* 軽故障 */}
                            <TableCell className={tableStyle.bodyCell} style={{ width: '124px' }}
                                onClick={(e) => {
                                    console.debug(["onClick"])
                                    if (editRow.DEV_INDEX != 0 && editRow.LMT_L == undefined) {
                                        //console.debug(["changeLmtL"])
                                        changeLmtL(0);
                                    }
                                }}
                            >
                                {editRow.LMT_L != undefined && editRow.DEV_INDEX != 0 ?
                                    <NumericEntry_inputEx
                                        className={tableStyle.textField}
                                        value={editRow.LMT_L == undefined ? 0 : editRow.LMT_L}
                                        fixed={2}
                                        maxValueLimit={10}
                                        minValueLimit={0}
                                        onChange={(val) => {
                                            changeLmtL(val);
                                        }}
                                    /> : ''
                                }
                            </TableCell>
                            {/* 重故障 */}
                            <TableCell className={tableStyle.bodyCell} style={{ width: '124px' }}
                                onClick={(e) => {
                                    console.debug(["onClick"])
                                    if (editRow.DEV_INDEX != 0 && editRow.LMT_H == undefined) {
                                        //console.debug(["changeLmtH"])
                                        changeLmtH(0);
                                    }
                                }}
                            >
                                {editRow.LMT_H != undefined && editRow.DEV_INDEX != 0 ?
                                    <NumericEntry_inputEx
                                        className={tableStyle.textField}
                                        value={editRow.LMT_H == undefined ? 0 : editRow.LMT_H}
                                        fixed={2}
                                        maxValueLimit={10}
                                        minValueLimit={0}
                                        onChange={(val) => {
                                            changeLmtH(val);
                                        }}
                                    /> : ''
                                }
                            </TableCell>
                        </TableRow>
                    </Table>
                </TableCell>
                {/* PD強度しきい値 */}
                <TableCell style={{ padding: '0px' }}>
                    <Table>
                        <TableRow>
                            {/* 軽故障 */}
                            <TableCell className={tableStyle.bodyCell} style={{ width: '124px' }}
                                onClick={(e) => {
                                    console.debug(["onClick"])
                                    if (editRow.DEV_INDEX != 0 && editRow.LMT_L_PD == undefined) {
                                        //console.debug(["changeLmtL"])
                                        changeLmtLPd(0);
                                    }
                                }}
                            >
                                {editRow.LMT_L_PD != undefined && editRow.DEV_INDEX != 0 ?
                                    <NumericEntry_inputEx
                                        className={tableStyle.textField}
                                        value={editRow.LMT_L_PD == undefined ? 0 : editRow.LMT_L_PD}
                                        fixed={2}
                                        maxValueLimit={10}
                                        minValueLimit={0}
                                        onChange={(val) => {
                                            changeLmtLPd(val);
                                        }}
                                    /> : ''
                                }
                            </TableCell>
                            {/* 重故障 */}
                            <TableCell className={tableStyle.bodyCell} style={{ width: '124px' }}
                                onClick={(e) => {
                                    console.debug(["onClick"])
                                    if (editRow.DEV_INDEX != 0 && editRow.LMT_H_PD == undefined) {
                                        //console.debug(["changeLmtH"])
                                        changeLmtHPd(0);
                                    }
                                }}
                            >
                                {editRow.LMT_H_PD != undefined && editRow.DEV_INDEX != 0 ?
                                    <NumericEntry_inputEx
                                        className={tableStyle.textField}
                                        value={editRow.LMT_H_PD == undefined ? 0 : editRow.LMT_H_PD}
                                        fixed={2}
                                        maxValueLimit={10}
                                        minValueLimit={0}
                                        onChange={(val) => {
                                            changeLmtHPd(val);
                                        }}
                                    /> : ''
                                }
                            </TableCell>
                        </TableRow>
                    </Table>
                </TableCell>
                {/**部分放電判定_最大値異常内容No */}
                <TableCell className={tableStyle.bodyCellLeft} style={{ width: '120px' }}
                    onClick={(e) => {
                        console.debug(["onClick"])
                        if (editRow.DEV_INDEX != 0 && editRow.TYP_NO_MAX == null) {
                            if (props.mclcTypIdMaxComboBoxItemList.length > 0) {
                                changeTypNoMax(props.mclcTypIdMaxComboBoxItemList[0].index);    //初期表示用にコンボボックス先頭の番号を入力
                            }
                        }
                    }}
                >
                    {editRow.TYP_NO_MAX != undefined && editRow.DEV_INDEX != 0 ?
                        <ItemComboBox
                            label={''}
                            itemList={props.mclcTypIdMaxComboBoxItemList}
                            value={editRow.TYP_NO_MAX}
                            labelStyle={tableStyle.labelStyle}
                            itemBoxStyle={tableStyle.itemBoxStyle}
                            onChangeEvent={(e) => {
                                if (typeof e.target.value === 'string') {
                                    console.debug(["e.target.value", e.target.value]);
                                    changeTypNoMax(parseInt(e.target.value));
                                }
                            }}
                        />
                        : ''
                    }
                </TableCell>
                {/**部分放電判定_PD強度異常内容No */}
                <TableCell className={tableStyle.bodyCellLeft} style={{ width: '120px' }}
                    onClick={(e) => {
                        console.debug(["onClick"])
                        if (editRow.DEV_INDEX != 0 && editRow.TYP_NO_PD == null) {
                            if (props.mclcTypIdPdComboBoxItemList.length > 0) {
                                changeTypNoPd(props.mclcTypIdPdComboBoxItemList[0].index);  //初期表示用にコンボボックス先頭の番号を入力
                            }
                        }
                    }}
                >
                    {editRow.TYP_NO_PD != undefined && editRow.DEV_INDEX != 0 ?
                        <ItemComboBox
                            label={''}
                            itemList={props.mclcTypIdPdComboBoxItemList}
                            value={editRow.TYP_NO_PD}
                            labelStyle={tableStyle.labelStyle}
                            itemBoxStyle={tableStyle.itemBoxStyle}
                            onChangeEvent={(e) => {
                                if (typeof e.target.value === 'string') {
                                    console.debug(["e.target.value", e.target.value]);
                                    changeTypNoPd(parseInt(e.target.value));
                                }
                            }}
                        />
                        : ''
                    }
                </TableCell>

            </TableRow>
        </>
    )
}

export default PartialDischargeCollectionBody;